export default __webpack_public_path__ + "static/media/circle-image.395404c1.svg";